import React, { useEffect, useState, useContext } from 'react';
import ProductListingModalItems from '../../Presentation/ProductListingModalItems';
import { UserOrderContext } from 'context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getAndCheck } from 'common/utilities/utils';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';

/**
 *  CustomizationAccordionComp Component
 * @param {*} props - Object
 */

const CustomizationAccordionComp = props => {
  const { grouplist = [], getSelectedModifiers, selectedModifiers, source = '' } = props;
  const { PDP } = MENU_PDP_PAGE_CONSTANTS;
  const [groupListItems, setGroupListItems] = useState(grouplist);
  const [selectedValue, setSelectedValue] = useState([]);

  // expandType can be `all` or `single`, default is `all`
  const { userOrderState } = useContext(UserOrderContext);
  const {
    pdpScreenCommons: { currentAccordian, modGroupIdsUpdated },
  } = userOrderState;

  const updateGroupList = list => {
    let mockGroupList = list.length ? list : [];
    mockGroupList.map((grpitem, idx) => {
      if (idx === 0) {
        grpitem.expanded = true;
      } else {
        grpitem.expanded = false;
      }
      return grpitem;
    });
    return mockGroupList;
  };

  const setGroupList = () => {
    let mockGroupList = updateGroupList(grouplist);
    setGroupListItems([...mockGroupList]);
  };

  const toggleAccordion = (event, id) => {
    event && preventFeature();
    let mockGroupList = groupListItems.length ? JSON.parse(JSON.stringify(groupListItems)) : [];
    mockGroupList.map((grpitem, idx) => {
      if (grpitem.id === id) {
        grpitem.expanded = !grpitem.expanded;
      }
      return grpitem;
    });
    setGroupListItems([...mockGroupList]);
  };

  const preventFeature = event => {
    event?.stopPropagation();
    event?.preventDefault();
  };

  useEffect(() => {
    setGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(grouplist)]);

  useEffect(() => {
    if (getAndCheck(currentAccordian, source === PDP)) {
      const grpList = grouplist?.length ? JSON.parse(JSON.stringify(grouplist)) : [];
      let mockGroupList = grpList.map((grpitem, idx) => {
        if (grpitem.id === currentAccordian) {
          const offset = grpitem.modifiers?.length > 1 ? 300 : 0;
          let scrollDiv = document.getElementById('accordion-' + currentAccordian).offsetTop;
          window.scrollTo({ top: scrollDiv - offset, behavior: 'smooth' });
          grpitem.expanded = true;
        } else {
          grpitem.expanded = false;
        }
        return grpitem;
      });
      setGroupListItems([...mockGroupList]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccordian, JSON.stringify(grouplist)]);

  const isUpdatedCheck = modgrpId => {
    let x = false;
    if (modGroupIdsUpdated && modGroupIdsUpdated.length) {
      let uniqueItems = [...new Set(modGroupIdsUpdated)];
      if (uniqueItems.includes(modgrpId)) {
        x = true;
      }
    }
    return x;
  };

  const showSelectedModifier = dataArr => {
    let jsonObject, uniqueSet, uniqueArray;
    if (dataArr.length) {
      jsonObject = dataArr.map(JSON.stringify);
      uniqueSet = new Set(jsonObject);
      uniqueArray = Array.from(uniqueSet).map(JSON.parse);
      let resultArr = [];
      if (selectedValue.length) {
        resultArr = selectedValue;
        let idToSplice = selectedValue.findIndex(sel => sel[0].modgrpId === uniqueArray[0].modgrpId);
        if (idToSplice >= 0) {
          resultArr.splice(idToSplice, 1, uniqueArray);
          setSelectedValue([...resultArr]);
        } else {
          setSelectedValue([...resultArr, uniqueArray]);
        }
      } else {
        setSelectedValue(oldValue => [...oldValue, uniqueArray]);
      }
    }
  };

  useEffect(() => {
    selectedValue.length && getSelectedModifiers(selectedValue);
    selectedModifiers(selectedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  const checkIfSelected = id => {
    let arr = [];
    for (let sel of selectedValue) {
      for (let item of sel) {
        if (item.modgrpId === id) {
          item.dname && item.dname.length && arr.push(item.dname[0].value);
        }
      }
    }
    return arr.join(', ');
  };

  return groupListItems.map(({ id, name, modifiers, expanded, min, max }, ind) => {
    const isUpdated = isUpdatedCheck(id);
    return (
      <React.Fragment key={ind}>
        <div className='accordian-container' id={'accordion-' + id} data-testid={`product-listing-accordion-${ind}`}>
          <div className='accordian-header'>
            <div
              className={`${expanded ? 'accordion active' : 'accordion'}`}
              data-testid={`toggle-accordion-${id}`}
              onClick={event => toggleAccordion(event, id)}
            >
              <span className='accordion-test' tabIndex='0'>
                {name}
              </span>
              {isUpdated ? <span className='updatedBadge'>{translateWithI18Next('updated')}</span> : null}
            </div>
            <span className='selected-mod'>{selectedValue.length && checkIfSelected(id)}</span>
          </div>
          <div className={`${expanded ? 'panel panel-active' : 'panel'}`}>
            <ProductListingModalItems
              modgrpId={id}
              modGrpName={name}
              data={modifiers}
              min={min}
              max={max}
              showSelectedModifier={showSelectedModifier}
            />
          </div>
        </div>
      </React.Fragment>
    );
  });
};

export default CustomizationAccordionComp;
